// Dizzplace - powiekszenie zdjecia na pelny ekran. JEDEN mechanizm na caly
// motyw (galeria produktu, zestaw probek, realizacje na glownej). Jak przy
// karuzeli (wzorzec z projektu Cossy): wlasny element HTML plus Swiper
// z plikow motywu.
//
// Swiper wstaje LENIWIE, przy pierwszym otwarciu. Powod: zamkniete
// powiekszenie jest na kazdej karcie produktu, a wiekszosc osob go nie otwiera.
//
// Zdjecia moga przyjsc z Liquida (galeria produktu) albo od skryptu, ktory
// wola `otworz(indeks, zdjecia)` - tak robi sekcja realizacji, bo pokazuje
// tylko te kafle, ktore przepuscil filtr.

if (!customElements.get('dizz-lightbox')) {
  class Powiekszenie extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowe === '1') return;
      this.dataset.gotowe = '1';

      this.poprzedniFokus = null;

      this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.zamknij());

      // Klik w tlo zamyka, klik w samo zdjecie nie - inaczej nie da sie go
      // powiekszyc gestem bez przypadkowego zamkniecia.
      this.addEventListener('click', (zdarzenie) => {
        if (zdarzenie.target === this || zdarzenie.target.classList.contains('lightbox__slide')) {
          this.zamknij();
        }
      });

      this.obslugaKlawiatury = (zdarzenie) => {
        if (this.hidden) return;
        if (zdarzenie.key === 'Escape') {
          this.zamknij();
          return;
        }
        if (zdarzenie.key === 'ArrowLeft') this.swiper?.slidePrev();
        if (zdarzenie.key === 'ArrowRight') this.swiper?.slideNext();

        // Pulapka na fokus: przy otwartym powiekszeniu tabulator nie moze
        // wyjsc do strony pod nim.
        if (zdarzenie.key === 'Tab') {
          const zamknij = this.querySelector('[data-lightbox-close]');
          zdarzenie.preventDefault();
          zamknij?.focus();
        }
      };
      document.addEventListener('keydown', this.obslugaKlawiatury);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.obslugaKlawiatury);
      if (this.swiper) this.swiper.destroy(true, true);
    }

    // Zdjecia od skryptu: `[{ src, srcset, alt, width, height }]`. Swiper po
    // podmianie slajdow trzeba postawic od nowa - `update()` nie nadaza za
    // wymiana calej zawartosci toru.
    ustawZdjecia(zdjecia) {
      const tor = this.querySelector('.swiper-wrapper');
      if (!tor) return;

      const biezace = JSON.stringify(zdjecia.map((zdjecie) => zdjecie.src));
      if (this.dataset.zrodlo === biezace) return;
      this.dataset.zrodlo = biezace;

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      tor.innerHTML = '';
      zdjecia.forEach((zdjecie) => {
        const slajd = document.createElement('div');
        slajd.className = 'swiper-slide lightbox__slide';

        const obraz = document.createElement('img');
        obraz.className = 'lightbox__image';
        obraz.src = zdjecie.src;
        if (zdjecie.srcset) obraz.srcset = zdjecie.srcset;
        obraz.sizes = '100vw';
        obraz.alt = zdjecie.alt || '';
        if (zdjecie.width) obraz.width = zdjecie.width;
        if (zdjecie.height) obraz.height = zdjecie.height;
        obraz.loading = 'lazy';

        slajd.appendChild(obraz);
        tor.appendChild(slajd);
      });

      // Przy jednym zdjeciu strzalki i kropki nie maja co robic.
      const pojedyncze = zdjecia.length < 2;
      this.querySelectorAll('[data-lightbox-prev], [data-lightbox-next], .lightbox__pagination').forEach((element) => {
        element.hidden = pojedyncze;
      });
    }

    uruchomKaruzele(indeks) {
      this.swiper = new window.Swiper(this.querySelector('.swiper-container'), {
        speed: 320,
        initialSlide: indeks,
        grabCursor: true,
        keyboard: false,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          prevEl: this.querySelector('[data-lightbox-prev]'),
          nextEl: this.querySelector('[data-lightbox-next]'),
        },
      });
    }

    otworz(indeks = 0, zdjecia = null) {
      if (Array.isArray(zdjecia) && zdjecia.length > 0) this.ustawZdjecia(zdjecia);
      if (this.querySelectorAll('.lightbox__slide').length === 0) return;

      this.poprzedniFokus = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add('lightbox-otwarty');

      if (this.swiper) {
        this.swiper.slideTo(indeks, 0);
        this.swiper.update();
      } else if (typeof window.Swiper === 'function') {
        this.uruchomKaruzele(indeks);
      } else if (window.dizzSwiper) {
        // Biblioteka wchodzi dopiero teraz - okno jest juz otwarte i pokazuje
        // pierwszy slajd, wiec klient nie czeka na nic przed zdjeciem.
        window.dizzSwiper.zaladuj().then(() => {
          if (!this.hidden && !this.swiper) this.uruchomKaruzele(indeks);
        }, () => {});
      }

      this.querySelector('[data-lightbox-close]')?.focus();
    }

    zamknij() {
      this.hidden = true;
      document.documentElement.classList.remove('lightbox-otwarty');
      if (this.poprzedniFokus && this.poprzedniFokus.focus) this.poprzedniFokus.focus();
    }
  }

  customElements.define('dizz-lightbox', Powiekszenie);
}

// Wyzwalacze zyja w galerii, nie w samym powiekszeniu, wiec podlaczamy je
// osobno - takze po podmianie sekcji w edytorze motywu.
//
// `data-lightbox-open` moze wskazac okno po identyfikatorze; puste bierze
// pierwsze okno na stronie. Numer zdjecia idzie z `data-lightbox-index`,
// a bez niego - z duzego zdjecia galerii produktu.
(() => {
  const podlacz = () => {
    document.querySelectorAll('[data-lightbox-open]').forEach((wyzwalacz) => {
      if (wyzwalacz.dataset.podlaczony === '1') return;
      wyzwalacz.dataset.podlaczony = '1';
      wyzwalacz.addEventListener('click', () => {
        const cel = wyzwalacz.getAttribute('data-lightbox-open');
        const okno = cel ? document.getElementById(cel) : document.querySelector('dizz-lightbox');
        if (!okno) return;

        let indeks = Number(wyzwalacz.dataset.lightboxIndex);
        if (!Number.isFinite(indeks) || wyzwalacz.dataset.lightboxIndex === undefined) {
          const glowne = document.querySelector('[data-gallery-main]');
          indeks = Number(glowne?.dataset.indeks) || 0;
        }

        customElements.whenDefined('dizz-lightbox').then(() => okno.otworz(indeks));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', podlacz);
  } else {
    podlacz();
  }
  document.addEventListener('shopify:section:load', podlacz);
})();
